import { api } from "@/features/utils/fetch-server";

/**
 * Generate JSON from a prompt with optional URL context
 */
export interface GenerateJSONRequest {
  /** Natural language description of what to generate */
  prompt: string;
  /** Optional URL to scrape for additional context */
  url?: string;
  /** Schema ID (e.g., "qualification_form", "onboarding_config") */
  json_id: string;
}

export class JSONGeneratorAPI {
  /**
   * Generate JSON from a prompt using LLM
   * @param request - Generation parameters
   * @returns Generated JSON data matching the specified schema
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async generate<T = any>(request: GenerateJSONRequest): Promise<T> {
    const response = await api.post<{ data: T }, GenerateJSONRequest>(
      `/api/utils/v1/generate`,
      request,
      { timeout: 120000 }, // 2 minute timeout for generation (web scraping + LLM can be slow)
    );
    return response.data;
  }
}
